// src/components/Footer.js
import React from 'react';

export default function Footer() {
  return (
    <footer style={{ padding: '2rem', textAlign: 'center', fontSize: '0.8rem', color: '#78716c', marginTop: '4rem', borderTop: '1px solid #e7e5e4' }}>
      <p>
        <strong>Disclaimer:</strong> TaxFlow is a tax estimation and document preparation tool provided "as is". 
        We are not a CPA firm, tax attorneys, or enrolled agents. 
        You are solely responsible for reviewing your return for accuracy before filing with the IRS. 
        We assume no liability for errors, penalties, or interest.
      </p>
      
      {/* --- ADD THIS LINK SECTION --- */}
      <p style={{ marginTop: '1rem' }}>
        <a href="/privacy.html" target="_blank" style={{ color: '#78716c', textDecoration: 'underline', marginRight: '15px' }}>Privacy Policy</a>
        <a href="mailto:chrisl@redsystem.dev" style={{ color: '#78716c', textDecoration: 'underline' }}>Contact Support</a>
      </p>

      <p>© {new Date().getFullYear()} TaxFlow. All data is stored locally on your device.</p>
    </footer>
  );
}